export const Config = {
    apiUrl: window.location.origin,
    //reCAPTCHASiteKey: "6LeilK8qAAAAAKXp5TArugnKi3Q3wWCfHqCAHKJ3"//local
    reCAPTCHASiteKey: "6Lfrm68qAAAAAD8iq-Sj_RoBU_L-mgW4T11z5T28"//dev
    //reCAPTCHASiteKey: "6Le-nK8qAAAAAOVHBVe3A1SSze5NGJsJIHA7ahJ-"//prod
};
